// ============================================================================
// MANACHER - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'manacher',
  name: 'Manacher',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'An algorithm for finding the longest palindromic substring in linear time. It uses symmetry properties of palindromes to avoid redundant comparisons and processes the string in a single pass.'
};
